import { Children, cloneElement, useRef } from 'react';
import { Stack } from '../Stack';
import { FieldHeaderComponent } from './Field';
import { CompoundFieldProps } from './FieldProps';
import { FieldContainer } from './style';

const CompoundField = ({
    children,
    label,
    name,
    required,
    caption,
    captionIcon,
    captionIconHandler,
    captionIconWithTooltip,
    ...other
}: CompoundFieldProps) => {
    const fieldWrapperRef = useRef<HTMLDivElement>(null);

    return (
        <FieldContainer ref={fieldWrapperRef} {...other}>
            <FieldHeaderComponent
                name={name}
                label={label}
                required={required}
                caption={caption}
                captionIcon={captionIcon}
                captionIconWithTooltip={captionIconWithTooltip}
                captionIconHandler={captionIconHandler}
                fieldWrapperRef={fieldWrapperRef}
            />
            <Stack spacing="100" distribution="stretch">
                {Children.map(children, (child) =>
                    cloneElement(child, {
                        ...child.props,
                        insideCompoundField: true,
                    })
                )}
            </Stack>
        </FieldContainer>
    );
};

export default CompoundField;
